module.exports = "/fonts/h2h-picturemark-l-d2b9cdfb61df9cbff3e84da8aabf2ded.svg";